import adiRMAStatus from "@NA/Handlers/ADIRMAStatusHandler";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import { getPaginationMessage } from "@NA/Utils/Utility";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Pagination, { PaginationPresentationProps, PaginationStyle } from "@insite/mobius/Pagination";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: CustomApplicationState) => ({
    getRMAStatusParams: state.ADIGlobalData.ADIRMAStatusStore.loadRMAStatusParameters,
    pagination: state.ADIGlobalData.ADIRMAStatusStore.rmaStatusResults?.pagination,
    isLoading: state.ADIGlobalData.ADIRMAStatusStore.isLoading,
});

const mapDispatchToProps = {
    adiRMAStatus,
};

export interface ReturnHistoryPagination {
    pagination?: PaginationPresentationProps;
    paginationWrap?: InjectableCss;
    paginationTotalCount?: InjectableCss;
}

export const paginationStyles: ReturnHistoryPagination = {
    paginationWrap: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: space-between;
            ${PaginationStyle} {
                margin: 0;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                nav li button {
                    min-height: unset;
                    min-width: 30px;
                    margin: 0;
                    border-right: 1px solid gray;
                    border-radius: 0px;
                    line-height: 14px;
                }
                nav li button span {
                    line-height: 14px;
                    min-width: unset !important;
                    margin: unset !important;
                    border-right: 0 !important;
                    padding: 0 !important;
                }
                ul ${TypographyStyle} {
                    min-width: 30px;
                    margin: 0;
                    border-right: 1px solid gray;
                    line-height: 14px;
                    max-height: 14px;
                    padding: 0 11px;
                    font-size: 14px;
                    display: inline-block;
                }
                nav li:last-child button {
                    border-right: 0 !important;
                }
            }
        `,
    },
    paginationTotalCount: {
        css: css`
            color: #002856;
            font-size: 14px;
            font-weight: 300;
            font-stretch: normal;
            font-style: normal;
            letter-spacing: normal;
            font-family: "Nunito Sans", sans-serif;
        `,
    },
};

const styles = paginationStyles;

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const ReturnHistoryPagination = ({ getRMAStatusParams, pagination, isLoading, adiRMAStatus }: Props) => {
    const changePage = (newPageIndex: number) => {
        adiRMAStatus({
            ...getRMAStatusParams,
            selectedPage: newPageIndex,
            onSuccess() { }
        });
    };

    const changeResultsPerPage = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newPageSize = parseInt(event.currentTarget.value, 10);
        adiRMAStatus({
            ...getRMAStatusParams,
            currentPageSize: "12",
            onSuccess() { }
        });
    };
    if (!pagination || pagination.totalItemCount === 0) {
        return null;
    }
    return (
        <StyledWrapper {...styles.paginationWrap}>
            <StyledWrapper {...styles.paginationTotalCount}>
                {/* Showing 1 - {pagination.pageSize} of {pagination.totalItemCount} */}
                {translate(
                    `Showing ${getPaginationMessage(
                        pagination?.page,
                        pagination?.pageSize,
                        pagination?.totalItemCount
                    )} `,
                )}
            </StyledWrapper>
            <Pagination
                {...styles.pagination}
                resultsCount={pagination.totalItemCount}
                currentPage={pagination.page}
                resultsPerPage={pagination.pageSize}
                resultsPerPageOptions={pagination.pageSizeOptions}
                onChangePage={changePage}
                onChangeResultsPerPage={changeResultsPerPage}
            />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ReturnHistoryPagination),
    definition: {
        group: "Basic",
        displayName: "Return History Pagination",
    },
};

export default widgetModule;
